export const AIR_API_CONFIG = {
  baseUrl: process.env.NEXT_PUBLIC_API_ENDPOINT!,
  wsUrl: process.env.NEXT_PUBLIC_WS_URL!,
};
